"use client";

import { ChatGuardrailsContainer, StaticBubble, Bubble } from "./ChatGuardrailsShared";

const STATES = ["IDLE", "HIDE_PLACEHOLDER", "AGENT_1_0", "USER_1_0", "USER_1_1", "AGENT_2_0", "AGENT_2_1", "SHOW_ALL"];

const AGENT_SPEAKING_STATES = ["AGENT_1_0", "AGENT_2_0", "AGENT_2_1"];

export function ChatTranscriptionDemo() {
  return (
    <ChatGuardrailsContainer
      backgroundImage='/assets/images/backgrounds/coral-2-bg.png'
      avatarSrc='/assets/images/avatars/avatar_1.png'
      states={STATES}
      agentSpeakingStates={AGENT_SPEAKING_STATES}
    >
      {m => (
        <>
          <m.div
            className='tw-absolute tw-top-0 tw-inset-x-0'
            initial={{ opacity: 1 }}
            animate={{ HIDE_PLACEHOLDER: { opacity: 0 } }}
          >
            <StaticBubble sentences={["Hi, how can I help you?"]} />
            <StaticBubble
              sentences={["My name is <PERSON_0> and my email is <EMAIL_ADDRESS_0>.", "Can you repeat my details?"]}
              variant='user'
              className='tw-mt-2'
            />
            <StaticBubble
              sentences={["I cannot repeat personal details.", "Can I help you with anything else?"]}
              className='tw-mt-2'
            />
          </m.div>

          <Bubble m={m} step='AGENT_1' sentences={["Hi, how can I help you?"]} />
          <Bubble
            m={m}
            step='USER_1'
            sentences={["My name is <PERSON_0> and my email is <EMAIL_ADDRESS_0>.", "Can you repeat my details?"]}
            variant='user'
            className='tw-mt-2'
            delay={1}
          />
          <Bubble
            m={m}
            step='AGENT_2'
            sentences={["I cannot repeat personal details.", "Can I help you with anything else?"]}
            className='tw-mt-2'
            delay={1}
          />
        </>
      )}
    </ChatGuardrailsContainer>
  );
}
